import './infoField.css';

const TRCInfoField = ({ label, value, icon }) => {
	return (
		<div className="trc-info-field">
			{icon && <span className="trc-info-icon">{icon}</span>}
			<div className="trc-info-content">
				<label>{label}</label>
				<p>{value}</p>
			</div>
		</div>
	);
};

export default TRCInfoField;
